import { Swiper } from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export default function initCarouselAmbassadors() {
  const container = document.querySelector(".swiper-ambassadors");
  if (!container) return;

  new Swiper(container, {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    allowTouchMove: true,
    navigation: {
      nextEl: ".swiper-ambassadors-next",
      prevEl: ".swiper-ambassadors-prev",
    },
    pagination: {
      el: ".swiper-ambassadors-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        return (
          '<span class="' + className + ' swiper-pagination-bullet-custom"></span>'
        );
      },
    },
  });
}
